/**
 * @generated SignedSource<<29003baaac1b739c3e96f949f3c84f59>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type ClassifyTxnsInputObject = {
  classification?: TxnClassificationEnum | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type transactionsPage_ClassifyTxnsMutation$variables = {
  input: ClassifyTxnsInputObject;
};
export type transactionsPage_ClassifyTxnsMutation$data = {
  readonly classifyTxns: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type transactionsPage_ClassifyTxnsMutation = {
  response: transactionsPage_ClassifyTxnsMutation$data;
  variables: transactionsPage_ClassifyTxnsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "transactionsPage_ClassifyTxnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassifyTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "classifyTxns",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "transactionsPage_ClassifyTxnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassifyTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "classifyTxns",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8eb9a0db61d24a0be0e4147d07dc2143",
    "id": null,
    "metadata": {},
    "name": "transactionsPage_ClassifyTxnsMutation",
    "operationKind": "mutation",
    "text": "mutation transactionsPage_ClassifyTxnsMutation(\n  $input: ClassifyTxnsInputObject!\n) {\n  classifyTxns(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bb7cda715b19bd23dcccced6c0fed900";

export default node;
